<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
            <app-action-alert controlName="breathsPerMinute" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
            <app-unit-quantity label="Breaths per min" unitLabel="br/min" placeholder="Value" inputMode="numeric" formControlName="breathsPerMinute"></app-unit-quantity>
            <app-checkbox label="Panting" formControlName="panting"></app-checkbox>
            <app-select label="Effort" placeholder="choose..." [items]="heartRhythmItems" [saveValue]="true" formControlName="effort"></app-select>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
	</div>
</app-action-form>